import React, { useState } from 'react';
import { db, auth } from '../../firebaseConfig';
import { useAuthState } from 'react-firebase-hooks/auth';
import { setDoc, doc } from 'firebase/firestore';
import '../../styles/AdminNotification.css';

const AdminSpecificNotification = () => {
  const [user] = useAuthState(auth);
  const [notificationTitle, setNotificationTitle] = useState('');
  const [notificationContent, setNotificationContent] = useState('');
  const [notificationUserId, setNotificationUserId] = useState('');

  const handleSpecificNotification = async () => {
    if (
      notificationTitle.trim() === '' ||
      notificationContent.trim() === '' ||
      notificationUserId.trim() === ''
    ) {
      alert('すべてのフィールドを入力してください。');
      return;
    }

    try {
      const notificationId = `${new Date().getTime()}`; // 通知の一意のIDを生成

      const notificationData = {
        title: notificationTitle,
        content: notificationContent,
        createdAt: new Date(),
        read: false,
      };

      // `specific_notifications`にデータを保存
      await setDoc(doc(db, 'specific_notifications', notificationId), notificationData);

      // `members/{userId}/notifications`にデータを保存
      await setDoc(
        doc(db, `members/${notificationUserId.trim()}/notifications`, notificationId),
        { ...notificationData, judge: 'spe' } // judgeフィールドを追加
      );

      setNotificationTitle('');
      setNotificationContent('');
      setNotificationUserId('');
      alert('通知を送信しました。');
    } catch (error) {
      console.error('Error sending specific notification:', error);
      alert('通知の送信に失敗しました。');
    }
  };

  return (
    <div className="admin-notification-container">
      <h2>特定のユーザーへの通知送信</h2>
      <div className="notification-form">
        <input
          type="text"
          value={notificationTitle}
          onChange={(e) => setNotificationTitle(e.target.value)}
          placeholder="通知のタイトルを入力"
        />
        <textarea
          value={notificationContent}
          onChange={(e) => setNotificationContent(e.target.value)}
          placeholder="通知の内容を入力"
          rows="4"
        />
        <input
          type="text"
          value={notificationUserId}
          onChange={(e) => setNotificationUserId(e.target.value)}
          placeholder="ユーザーIDを入力"
        />
        <button onClick={handleSpecificNotification}>送信</button>
      </div>
    </div>
  );
};

export default AdminSpecificNotification;
